// extracted by mini-css-extract-plugin
module.exports = {"tagButton":"PostAddTagAction__tagButton__x09UV"};